/**
 * @module beebee-base/lib/utility/sdi
 * @description SDI (Sistema di Interscambio) code utilities.
 *
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — SDI/TS status code → Italian label / CSS class / icon
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  sibling lib/utility/*.js modules (all re-exported via ../utility.js barrel)
 *   tests:     utility-test.js, utility-wave4-test.js, utility-wave5-test.js
 */

/** Mappatura codici SDI a traduzioni italiane */
const SDI_CODE_TRANSLATIONS = Object.freeze({
  HDO10: 'Presa in carico da Poppix',
  HDO00: 'In attesa di risposta da SDI',
  HDO01: 'Accettata',
  HDO02: 'Rifiutata',
  HDO03: 'Decorrenza Termini',
  HDO04: 'Recapito Impossibile',
  HDO05: 'Emessa e consegnata',
  HDO06: 'Emessa e non Consegnata ',
  HDO07: 'Scartata'
});

/** Mappatura codici SDI a classi CSS */
const SDI_CODE_CLASSES = Object.freeze({
  HDO10: 'text-warning',
  HDO00: 'text-warning',
  HDO01: 'text-success',
  HDO02: 'text-alert',
  HDO03: 'text-alert',
  HDO04: 'text-warning',
  HDO05: 'text-success',
  HDO06: 'text-success',
  HDO07: 'text-alert'
});

/** Mappatura codici SDI a icone */
const SDI_CODE_ICONS = Object.freeze({
  HDO10: 'clock',
  HDO00: 'clock',
  HDO01: 'check',
  HDO02: 'xmark',
  HDO03: 'xmark',
  HDO04: 'exclamation',
  HDO05: 'check',
  HDO06: 'check',
  HDO07: 'xmark'
});

/**
 * Traduce un codice SDI in italiano
 * @param {string} code - Codice SDI
 * @returns {string|null} Traduzione o null
 */
function sdiCodeToIta(code) {
  return SDI_CODE_TRANSLATIONS[code] ?? null;
}

/**
 * Converte un codice TS in classe CSS
 * @param {string} code - Codice TS
 * @returns {string|null} Classe CSS
 */
function tsCodeToClass(code) {
  if (code === '0') {
    return 'text-success';
  }
  return code ? 'text-alert' : null;
}

/**
 * Converte un codice SDI in classe CSS
 * @param {string} code - Codice SDI
 * @returns {string} Classe CSS
 */
function sdiCodeToClass(code) {
  return SDI_CODE_CLASSES[code] ?? '';
}

/**
 * Converte un codice SDI in nome icona
 * @param {string} code - Codice SDI
 * @returns {string} Nome icona
 */
function sdiCodeToIcon(code) {
  return SDI_CODE_ICONS[code] ?? '';
}

export { sdiCodeToClass, sdiCodeToIcon, sdiCodeToIta, tsCodeToClass };
//# sourceMappingURL=sdi.js.map
